export const vodeNavEvents = Object.freeze({
    TOGGLE_TO_SEE_ALL: 'toggle-to-see-all'
});

export const vodNavModeTypes = Object.freeze({
    VOD: 'vod'
});
